module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [(_vm.valid) ? _c('div', [(_vm.working) ? _c('div', {
    staticClass: "working"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v("Academy data is being processed. This may take a few minutes.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pull-right clearfix"
  }, [_c('div', [_c('strong', [_vm._v("Last Sync:")]), _vm._v(" " + _vm._s(_vm.status.lastSync) + "    "), _c('strong', [_vm._v("Status:")]), _vm._v(" " + _vm._s(_vm.status.status))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    attrs: {
      "disabled": !_vm.status.syncAvailable
    },
    on: {
      "click": _vm.confirmSync
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Sync Now")]), _vm._v("   \n\t\t\t\t"), _c('router-link', {
    attrs: {
      "tag": "button",
      "to": {
        name: 'troubleshooting',
        params: {
          acadid: _vm.academy.id
        }
      },
      "disabled": !_vm.status.syncAvailable
    }
  }, [_c('i', {
    staticClass: "fa fa-address-card"
  }), _vm._v(" Troubleshoot")])])]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.academy.name))]), _vm._v(" "), (_vm.confirm.enabled) ? _c('confirm', {
    on: {
      "cancel": function($event) {
        _vm.confirm.enabled = false
      },
      "confirm": _vm.onConfirm
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.confirm.msg)
    },
    slot: "body"
  })]) : _vm._e(), _vm._v(" "), (_vm.progress.active) ? _c('div', {
    staticClass: "section"
  }, [_c('h3', [_vm._v("Sync Progress")]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-success progress-bar-striped active",
    style: ({
      width: _vm.progress.percent + '%'
    })
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.progress.percent) + "% Complete - " + _vm._s(_vm.progress.msg))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section sync-actions clearfix"
  }, [_c('h3', [_vm._v("Options")]), _vm._v(" "), _c('div', {
    staticClass: "toggles"
  }, [_c('div', {
    staticClass: "option-group"
  }, [_c('span', {
    staticClass: "action-label"
  }, [_vm._v("HRID sync:")]), _vm._v(" "), _c('Toggle', {
    attrs: {
      "value": _vm.hridSync
    },
    on: {
      "change": _vm.confirmToggleHRID
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "option-group"
  }, [_c('span', {
    staticClass: "action-label"
  }, [_vm._v("ASC user sync:")]), _vm._v(" "), _c('Toggle', {
    attrs: {
      "value": _vm.ascUserSync
    },
    on: {
      "change": _vm.confirmToggleASC
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "option-group"
  }, [_c('span', {
    staticClass: "action-label"
  }, [_vm._v("Push HRIDs to Schoox:")]), _vm._v(" "), _c('Toggle', {
    attrs: {
      "value": _vm.hridPush
    },
    on: {
      "change": _vm.confirmPushHRID
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "delay-options"
  }, [_c('span', {
    staticClass: "action-label"
  }, [_vm._v("Delay removal:")]), _vm._v(" "), _c('Toggle', {
    attrs: {
      "value": _vm.delay.action
    },
    on: {
      "change": _vm.confirmDelayRemove
    }
  }), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.days),
      expression: "days"
    }],
    staticClass: "form-control delay-days",
    attrs: {
      "type": "number",
      "disabled": !_vm.delay.action,
      "min": "delayMin",
      "max": "delayMax"
    },
    domProps: {
      "value": _vm._s(_vm.days)
    },
    on: {
      "blur": [_vm.saveDelayDays, function($event) {
        _vm.$forceUpdate()
      }],
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.saveDelayDays($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.days = _vm._n($event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "ignore-container"
  }, [_c('div', [_c('span', {
    staticClass: "action-label"
  }, [_vm._v("HotSchedules id ignore list:")]), _vm._v(" "), _c('div', {
    staticClass: "add-ignore-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ignoreToAdd),
      expression: "ignoreToAdd"
    }],
    staticClass: "ignore-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.ignoreToAdd)
    },
    on: {
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.addIgnore($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ignoreToAdd = $event.target.value
      }
    }
  }), _c('button', {
    on: {
      "click": _vm.addIgnore
    }
  }, [_vm._v("Add HotSchedules id")])])]), _vm._v(" "), _c('div', {
    staticClass: "ignores-list"
  }, _vm._l((_vm.ignores), function(ignore) {
    return _c('span', {
      staticClass: "ignore-item"
    }, [_vm._v(_vm._s(ignore) + " "), _c('i', {
      staticClass: "fa fa-times",
      on: {
        "click": function($event) {
          _vm.removeIgnore(ignore)
        }
      }
    })])
  }))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('h3', [_vm._v("Pay Type Mappings")]), _vm._v(" "), (_vm.paytypeJobsReady) ? _c('div', [_c('pay-config', {
    attrs: {
      "hourly": _vm.hourly,
      "salary": _vm.salary
    },
    on: {
      "update": _vm.updatePayType
    }
  })]) : _c('div', [_c('p', [_vm._v(_vm._s(_vm.paytypeJobsMessage))])]), _vm._v(" ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('h3', [_vm._v("Exclude Jobs")]), _vm._v(" "), (_vm.jobsmapReady) ? _c('div', [_c('exclude-jobs', {
    attrs: {
      "available": _vm.syncedJobs,
      "excluded": _vm.exludedJobs
    },
    on: {
      "update": _vm.updateExcludedJobs
    }
  })]) : _c('div', [_c('p', [_vm._v(_vm._s(_vm.jobsmapMessage))])]), _vm._v(" ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('h3', [_vm._v("Job Name Mappings")]), _vm._v(" "), (_vm.jobsmapReady) ? _c('div', [_c('table', {
    staticClass: "table table-striped table-bordered config-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Schoox Job Name")]), _vm._v(" "), _c('th', [_vm._v("HS Job Names")]), _vm._v(" "), _c('th', [_vm._v("# Jobs")]), _vm._v(" "), _c('th', [_c('button', {
    on: {
      "click": function($event) {
        _vm.editJobMapping(_vm.jobsmap.length)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Add Job Mapping")])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.jobsmap), function(row, index) {
    return [(_vm.jobEditor.index === index) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": "4"
      }
    }, [_c('job-config', {
      attrs: {
        "toName": row.scxJobName,
        "hsNames": row.hsNames,
        "index": index,
        "available": _vm.availableJobs,
        "restricted": _vm.getRestrictedNames(row.scxJobName)
      },
      on: {
        "ready": _vm.scroll,
        "cancel": _vm.cancelJobMapEdit,
        "finish": _vm.finishJobNameEdit
      }
    })])]) : _c('tr', [_c('td', [_vm._v(_vm._s(row.scxJobName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.hsNames.join(', ')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.hsNames.length))]), _vm._v(" "), _c('td', [_c('button', {
      on: {
        "click": function($event) {
          _vm.editJobMapping(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Edit")]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          _vm.confirmJobNameRemove(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Remove")])])]), _vm._v(" ")]
  }), _vm._v(" "), (_vm.jobEditor.index === _vm.jobsmap.length) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('job-config', {
    attrs: {
      "index": _vm.jobsmap.length,
      "available": _vm.availableJobs,
      "restricted": _vm.getRestrictedNames()
    },
    on: {
      "ready": _vm.scroll,
      "cancel": _vm.cancelJobMapEdit,
      "finish": _vm.finishJobNameEdit
    }
  })])]) : _vm._e()], true)]), _vm._v(" "), (!_vm.jobsmap.length) ? _c('p', [_vm._v("No Job Name Mappings. Click Add Job Name Mapping to get started.")]) : _vm._e()]) : _c('div', [_c('p', [_vm._v(_vm._s(_vm.jobsmapMessage))])]), _vm._v(" ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    attrs: {
      "tag": "button",
      "to": {
        name: 'mapping',
        params: {
          acadid: _vm.academy.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-map"
  }), _vm._v(" Add Mapping")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.confirmRemoveAll
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Remove All Mappings")])]), _vm._v(" "), _c('h3', [_vm._v("Academy Mappings")]), _vm._v(" "), _c('v-client-table', {
    attrs: {
      "data": _vm.tableData,
      "columns": _vm.columns,
      "options": _vm.options
    }
  })])]) : _c('div', [_c('h2', [_vm._v("No Academy found for " + _vm._s(_vm.$route.params.id))])]), _vm._v(" ")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-651d020b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Academy.vue
// module id = 414
// module chunks = 2